import component from './PhNumberFive.vue_vue&type=script&lang.js';
export { default } from './PhNumberFive.vue_vue&type=script&lang.js';
import { render } from './PhNumberFive.vue_vue&type=template&id=58213c3b&lang.js';

component.render = render;
